module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/WizardButton/images/border-normal.9063f468.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/WizardButton/images/border-normal.png
// module id = 2538
// module chunks = 11